import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoading: false,
  operationType: undefined,
  calendars: [],
  schedules: [],
  scheduleDetail: null,
  accountSchedule: [],
  upcomingCalendars: [],
}

export const calendarSlice = createSlice({
  name: 'calendar',
  initialState: { ...initialState },
  reducers: {
    sagaSuccess: (state, action) => {
      if (action.payload) {
        Object.assign(state, action.payload);
      }
    },
    sagaFailed: (state, action) => {
      state.operationType = undefined;
      state.isLoading = false
    },
    resetCalendarReducer: (state, action) => {
      if (action.payload) {
        Object.assign(state, action.payload);
      }
    },
    getCalendar: (state, action) => {
      state.isLoading = true;
    },
    getScheduleDetail: (state, action) => {
      state.isLoading = true;
    },
    getEntitySchedule: (state, action) => {
      state.isLoading = true;
    },
    getEntityUpcomingSchedule: (state, action) => {
      state.isLoading = true;
    }
  }
})

export const {
  sagaSuccess,
  resetCalendarReducer,
  getCalendar,
  getScheduleDetail,
  sagaFailed,
  getEntitySchedule,
  getEntityUpcomingSchedule
} = calendarSlice.actions

export default calendarSlice.reducer